// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer.css */
.footer {
    padding: 20px 0;
    text-align: center;
}
.footer {
    color: #111525;
    font-size: 12px;
    padding: 18px 0 100px;
    text-align: center;
}

.footerdev {
    background-color: #111525;
    color: #B3B3B3 !important;
    font-size: 12px;
    text-align: center;
    padding: 18px 0 11px;
}

.footer-nav ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: inline-flex;
    gap: 15px;
}

.footer-nav ul li {
    display: inline;
    font-size: 12px;
}

.footer-nav ul li a {
    text-decoration: none;
    color: #B3B3B3;
    font-size: 14px;
}

.footer-nav ul li:after {
    content: "|";
    display: inline-block;
    vertical-align: baseline;
    margin: 0 -1px 0 8px;
}

.footer-nav ul li:last-child:after {
    content: "";
}
.footer-nav ul li a:hover {
    text-decoration: underline;
}

.footer-nav ul li.last a {
    font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/footer.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,WAAW;AACf;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":["/* Footer.css */\n.footer {\n    padding: 20px 0;\n    text-align: center;\n}\n.footer {\n    color: #111525;\n    font-size: 12px;\n    padding: 18px 0 100px;\n    text-align: center;\n}\n\n.footerdev {\n    background-color: #111525;\n    color: #B3B3B3 !important;\n    font-size: 12px;\n    text-align: center;\n    padding: 18px 0 11px;\n}\n\n.footer-nav ul {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    display: inline-flex;\n    gap: 15px;\n}\n\n.footer-nav ul li {\n    display: inline;\n    font-size: 12px;\n}\n\n.footer-nav ul li a {\n    text-decoration: none;\n    color: #B3B3B3;\n    font-size: 14px;\n}\n\n.footer-nav ul li:after {\n    content: \"|\";\n    display: inline-block;\n    vertical-align: baseline;\n    margin: 0 -1px 0 8px;\n}\n\n.footer-nav ul li:last-child:after {\n    content: \"\";\n}\n.footer-nav ul li a:hover {\n    text-decoration: underline;\n}\n\n.footer-nav ul li.last a {\n    font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
